var insertResults = require('./insert-results');

module.exports = function (apiEndpoint) {
    var $page = $('#landing-page-with-search');
    var $paginationContainer = $page.find("div[class*='pagination']");

    if ($paginationContainer.length) {
        var $pageLinks = $paginationContainer.find('[data-pagination-page]');

        $pageLinks.click(function (e) {
            var page = $(this).data('paginationPage');
            window.page = page;

            insertResults(apiEndpoint);

            return false;
        });
    }
};